import React from 'react';
import { GoogleLogin as GoogleLoginComponent } from '@react-oauth/google';
import { Navigate, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const API_URL = process.env['API_URL'] || '';
const API_KEY = process.env['API_KEY'] || '';
const API_VERSION = process.env['API_VERSION'] || '';

const GoogleLogin = () => {
  const navigate = useNavigate();
  const { login, isLoading, isAuthenticated } = useAuth();

  const handleSuccess = async (credentialResponse: any) => {
    const response = await fetch(`${API_URL}/${API_VERSION}/auth/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'x-api-key': API_KEY,
      },
      body: JSON.stringify({
        credential: credentialResponse.credential,
      }),
    });

    const { data } = await response.json();

    login(data?.token, data?.user)

    navigate("/", { replace: true });
  };

  if(isLoading) {
    return <p>Loading...</p>;
  }

  if(isAuthenticated) {
    return <Navigate to="/" replace/>;
  }

  return (
    <GoogleLoginComponent
      onSuccess={handleSuccess}
      onError={() => console.log('Login Failed')}
    />
  );
}

export default GoogleLogin;
